var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"tint-full-screen solid-tint-black-black80 pos-fix solid-tint-black-black80 z-index-10"})}
var staticRenderFns = []

export { render, staticRenderFns }